module.exports = __webpack_public_path__ + "static/media/appslk.1af421d7.jpg";